module.exports = __webpack_public_path__ + "img/recovr.fd66f6c6.png";